import React, { useState } from 'react';
import './Navbar.css';

const Navbar = ({ onOpenModal }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <nav className="navbar">
      <div className={`navbar-container ${isMenuOpen ? 'open' : ''}`}>
        <div className="navbar-brand" onClick={() => setIsMenuOpen(!isMenuOpen)}>
          <span className="navbar-brand-text">Alix Caperan</span>
          <span className={`dropdown-arrow ${isMenuOpen ? 'open' : ''}`}>▼</span>
        </div>
        <div className={`navbar-links ${isMenuOpen ? 'show' : ''}`}>
          <a href="#solution" className="navbar-link" onClick={() => setIsMenuOpen(false)}>Mon expertise</a>
          <a href="#pricing" className="navbar-link" onClick={() => setIsMenuOpen(false)}>Mes offres</a>
          <a href="#projects" className="navbar-link" onClick={() => setIsMenuOpen(false)}>Exemples de mes projets</a>
        </div>
      </div>
      <button onClick={onOpenModal} className="navbar-cta-button">
        <img src="/photo/equipe/photo-cv-entier.png" alt="" className="navbar-cta-avatar" />
        <span className="button-text">
          <span className="text-default">Lancer un projet</span>
          <span className="text-hover">On est partis ?</span>
        </span>
      </button>
      {isMenuOpen && <div className="overlay" onClick={() => setIsMenuOpen(false)}></div>}
    </nav>
  );
};


export default Navbar;
